module.exports = __webpack_public_path__ + "img/theConstructionIndustryCertificate.a1b2a9c7.png";